export default "__VITE_ASSET__Ddk62T$h__"